module.exports = __webpack_public_path__ + "img/collection_list.c67173bd.png";